import React from "react";
import { css } from "emotion";
import { boxStyles } from "../styles/theme";

const MobileSwitcher = ({ mobileComponent, desktopComponent }) => {
  return (
    <div className={container}>
      <div className="mobile">{mobileComponent}</div>
      <div className="desktop">{desktopComponent}</div>
    </div>
  );
};

export default MobileSwitcher;

const container = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  .mobile,
  .desktop {
    flex: 1;
  }
  .desktop {
    display: none;
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .desktop {
      display: flex;
    }
    .mobile {
      display: none;
    }
  }
`;
